<template>
  <div class="payment-config">
    <div class="box">
      <div class="p16">
        <div class="pb16 flex jc_b ai_c">
          <div class="flex jc_s">
            <i class="iconfont iconzhifu f16 lan"></i>
            <span class="col666 f14 ml10">支付配置管理</span>
          </div>
          <div class="flex jc_end f14 col333 ai_c">
            <el-button type="primary" @click="showAddDialog" class="ssbtn">
              <i class="el-icon-plus"></i> 添加支付配置
            </el-button>
          </div>
        </div>

        <!-- 支付配置列表 -->
        <div class="table">
          <el-table :data="paymentList" border style="width: 100%" size="medium">
            <el-table-column prop="id" label="ID" min-width="80" align="center"></el-table-column>
            <el-table-column prop="name" label="配置名称" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="type" label="支付类型" min-width="120" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.type === 'alipay' ? 'primary' : 'success'">
                  {{ scope.row.type === 'alipay' ? '支付宝' : '微信支付' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
                  {{ scope.row.status === 1 ? '生效中' : '未生效' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="240" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" @click="editConfig(scope.row)">编辑</el-button>
                <el-button 
                  size="mini" 
                  :type="scope.row.status === 1 ? 'warning' : 'success'"
                  @click="toggleStatus(scope.row)"
                >
                  {{ scope.row.status === 1 ? '停用' : '启用' }}
                </el-button>
                <el-button size="mini" type="danger" @click="deleteConfig(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination mt20">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加/编辑支付配置对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="formData" :rules="formRules" ref="paymentForm" label-width="140px">
        <el-form-item label="配置名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入配置名称"></el-input>
        </el-form-item>
        
        <el-form-item label="支付类型" prop="type">
          <el-radio-group v-model="formData.type" @change="onTypeChange">
            <el-radio label="alipay">支付宝</el-radio>
            <el-radio label="wechat">微信支付</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 支付宝配置 -->
        <template v-if="formData.type === 'alipay'">
          <el-form-item label="商户号" prop="mch_no">
            <el-input v-model="formData.mch_no" placeholder="请输入支付宝商户号"></el-input>
          </el-form-item>
          
          <el-form-item label="APP ID" prop="app_id">
            <el-input v-model="formData.app_id" placeholder="请输入支付宝APP ID"></el-input>
          </el-form-item>
          
          <el-form-item label="应用密钥" prop="app_key">
            <el-input 
              type="textarea" 
              v-model="formData.app_key" 
              placeholder="请输入支付宝应用密钥"
              :rows="4"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="支付网关地址" prop="pay_host">
            <el-input v-model="formData.pay_host" placeholder="请输入支付宝支付网关地址"></el-input>
          </el-form-item>
        </template>

        <!-- 微信支付配置 -->
        <template v-if="formData.type === 'wechat'">
          <el-form-item label="APP APPID" prop="app_appid">
            <el-input v-model="formData.app_appid" placeholder="请输入APP APPID"></el-input>
          </el-form-item>
          
          <el-form-item label="公众号APPID" prop="mp_appid">
            <el-input v-model="formData.mp_appid" placeholder="请输入公众号APPID"></el-input>
          </el-form-item>
          
          <el-form-item label="公众号APP SECRET" prop="mp_app_secret">
            <el-input v-model="formData.mp_app_secret" placeholder="请输入公众号APP SECRET"></el-input>
          </el-form-item>
          
          <el-form-item label="小程序APPID" prop="mini_appid">
            <el-input v-model="formData.mini_appid" placeholder="请输入小程序APPID"></el-input>
          </el-form-item>
          
          <el-form-item label="商户号ID" prop="mch_id">
            <el-input v-model="formData.mch_id" placeholder="请输入微信支付商户号ID"></el-input>
          </el-form-item>
          
          <el-form-item label="商户密钥" prop="mch_key">
            <el-input v-model="formData.mch_key" placeholder="请输入微信支付商户密钥"></el-input>
          </el-form-item>
          
          <el-form-item label="回调通知地址" prop="notify_url">
            <el-input v-model="formData.notify_url" placeholder="请输入回调通知地址"></el-input>
          </el-form-item>
          
          <el-form-item label="API证书CERT" prop="cert_content">
            <el-input 
              type="textarea" 
              v-model="formData.cert_content" 
              placeholder="请输入微信支付API证书CERT内容"
              :rows="4"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="API证书KEY" prop="key_content">
            <el-input 
              type="textarea" 
              v-model="formData.key_content" 
              placeholder="请输入微信支付API证书KEY内容"
              :rows="4"
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/api'

export default {
  name: 'PaymentConfig',
  data() {
    return {
      // 列表数据
      paymentList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      
      // 对话框
      dialogVisible: false,
      dialogTitle: '添加支付配置',
      isEdit: false,
      editId: null,
      
      // 表单数据
      formData: {
        name: '',
        type: 'alipay',
        // 支付宝字段
        mch_no: '',
        app_id: '',
        app_key: '',
        pay_host: '',
        // 微信支付字段
        app_appid: '',
        mp_appid: '',
        mp_app_secret: '',
        mini_appid: '',
        mch_id: '',
        mch_key: '',
        notify_url: '',
        cert_content: '',
        key_content: ''
      },
      
      // 表单验证规则
      formRules: {
        name: [
          { required: true, message: '请输入配置名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择支付类型', trigger: 'change' }
        ],
        mch_no: [
          { required: true, message: '请输入支付宝商户号', trigger: 'blur' }
        ],
        app_id: [
          { required: true, message: '请输入支付宝APP ID', trigger: 'blur' }
        ],
        app_key: [
          { required: true, message: '请输入支付宝应用密钥', trigger: 'blur' }
        ],
        pay_host: [
          { required: true, message: '请输入支付宝支付网关地址', trigger: 'blur' },
          { type: 'url', message: '请输入正确的URL地址', trigger: 'blur' }
        ],
        app_appid: [
          { required: true, message: '请输入APP APPID', trigger: 'blur' }
        ],
        mp_appid: [
          { required: true, message: '请输入公众号APPID', trigger: 'blur' }
        ],
        mp_app_secret: [
          { required: true, message: '请输入公众号APP SECRET', trigger: 'blur' }
        ],
        mini_appid: [
          { required: true, message: '请输入小程序APPID', trigger: 'blur' }
        ],
        mch_id: [
          { required: true, message: '请输入商户号ID', trigger: 'blur' }
        ],
        mch_key: [
          { required: true, message: '请输入商户密钥', trigger: 'blur' }
        ],
        cert_content: [
          { required: true, message: '请输入API证书CERT内容', trigger: 'blur' }
        ],
        key_content: [
          { required: true, message: '请输入API证书KEY内容', trigger: 'blur' }
        ]
      }
    }
  },
  
  mounted() {
    this.getPaymentList()
  },
  
  methods: {
    // 获取支付配置列表
    async getPaymentList() {
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize
        }
        
        const response = await api.getPaymentConfigList(params)
        
        if (response.data.code === 0) {
          this.paymentList = response.data.data.list || []
          this.total = response.data.data.total || 0
        } else {
          this.$message.error(response.data.msg || '获取支付配置列表失败')
        }
      } catch (error) {
        console.error('获取支付配置列表失败:', error)
        this.$message.error('获取支付配置列表失败')
      }
    },
    
    // 显示添加对话框
    showAddDialog() {
      this.dialogTitle = '添加支付配置'
      this.isEdit = false
      this.editId = null
      this.resetForm()
      this.dialogVisible = true
    },
    
    // 编辑配置
    async editConfig(row) {
      this.dialogTitle = '编辑支付配置'
      this.isEdit = true
      this.editId = row.id
      
      // 先重置表单
      this.resetForm()
      
      try {
        const response = await api.getPaymentConfigDetail({ id: row.id })
        
        console.log('编辑配置API响应:', response) // 调试信息
        
        if (response.data.code === 0) {
          const config = response.data.data
          console.log('配置数据:', config) // 调试信息
          
          if (!config) {
            console.error('配置数据为空')
            this.$message.error('配置数据为空')
            return
          }
          
          // 使用 $nextTick 确保表单已经重置完成
          this.$nextTick(() => {
            this.formData = {
              name: config.name || '',
              type: config.type || 'alipay',
              // 支付宝字段
              mch_no: config.mch_no || '',
              app_id: config.app_id || '',
              app_key: config.app_key || '',
              pay_host: config.pay_host || '',
              // 微信支付字段
              app_appid: config.app_appid || '',
              mp_appid: config.mp_appid || '',
              mp_app_secret: config.mp_app_secret || '',
              mini_appid: config.mini_appid || '',
              mch_id: config.mch_id || '',
              mch_key: config.mch_key || '',
              notify_url: config.notify_url || '',
              cert_content: config.cert_content || '',
              key_content: config.key_content || ''
            }
            
            console.log('设置的表单数据:', this.formData) // 调试信息
            
            // 清除表单验证
            if (this.$refs.paymentForm) {
              this.$refs.paymentForm.clearValidate()
            }
          })
          
          this.dialogVisible = true
        } else {
          console.error('API返回错误:', response.data)
          this.$message.error(response.data.msg || '获取配置详情失败')
        }
      } catch (error) {
        console.error('获取配置详情失败:', error)
        this.$message.error('获取配置详情失败')
      }
    },
    
    // 切换状态
    toggleStatus(row) {
      const action = row.status === 1 ? '停用' : '启用'
      this.$confirm(`确定要${action}该支付配置吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await api.setPaymentConfigStatus({
            id: row.id,
            status: row.status === 1 ? 0 : 1
          })
          
          if (response.data.code === 0) {
            this.$message.success(`${action}成功`)
            this.getPaymentList() // 重新获取列表
          } else {
            this.$message.error(response.data.msg || `${action}失败`)
          }
        } catch (error) {
          console.error('切换状态失败:', error)
          this.$message.error(`${action}失败`)
        }
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    
    // 删除配置
    deleteConfig(row) {
      this.$confirm('确定要删除该支付配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await api.deletePaymentConfig({ id: row.id })
          
          if (response.data.code === 0) {
            this.$message.success('删除成功')
            this.getPaymentList() // 重新获取列表
          } else {
            this.$message.error(response.data.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    // 支付类型改变
    onTypeChange() {
      // 清空表单数据（除了基本信息）
      const { name, type } = this.formData
      this.resetForm()
      this.formData.name = name
      this.formData.type = type
    },
    
    // 重置表单
    resetForm() {
      this.formData = {
        name: '',
        type: 'alipay',
        mch_no: '',
        app_id: '',
        app_key: '',
        pay_host: '',
        app_appid: '',
        mp_appid: '',
        mp_app_secret: '',
        mini_appid: '',
        mch_id: '',
        mch_key: '',
        notify_url: '',
        cert_content: '',
        key_content: ''
      }
      
      if (this.$refs.paymentForm) {
        this.$refs.paymentForm.clearValidate()
      }
    },
    
    // 提交表单
    submitForm() {
      this.$refs.paymentForm.validate(async (valid) => {
        if (valid) {
          try {
            let response
            
            if (this.isEdit) {
              // 编辑
              response = await api.updatePaymentConfig({
                id: this.editId,
                ...this.formData
              })
            } else {
              // 新增
              response = await api.createPaymentConfig(this.formData)
            }
            
            if (response.data.code === 0) {
              this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
              this.dialogVisible = false
              this.resetForm()
              this.getPaymentList() // 重新获取列表
            } else {
              this.$message.error(response.data.msg || '操作失败')
            }
          } catch (error) {
            console.error('提交表单失败:', error)
            this.$message.error('操作失败')
          }
        }
      })
    },
    
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getPaymentList()
    },
    
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPaymentList()
    }
  }
}
</script>

<style scoped>
.payment-config {
  background: #f5f5f5;
  min-height: 100vh;
}

.box {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.p16 {
  padding: 16px;
}

.pb16 {
  padding-bottom: 16px;
}

.ml10 {
  margin-left: 10px;
}

.ml15 {
  margin-left: 15px;
}

.mr20 {
  margin-right: 20px;
}

.mt20 {
  margin-top: 20px;
}

.flex {
  display: flex;
}

.jc_s {
  justify-content: flex-start;
}

.jc_b {
  justify-content: space-between;
}

.jc_end {
  justify-content: flex-end;
}

.ai_c {
  align-items: center;
}

.f14 {
  font-size: 14px;
}

.f16 {
  font-size: 16px;
}

.col666 {
  color: #666;
}

.col333 {
  color: #333;
}

.lan {
  color: #409EFF;
}

.ssbtn {
  background: #409EFF;
  border-color: #409EFF;
}

.pagination {
  text-align: right;
}

.dialog-footer {
  text-align: right;
}

.el-textarea {
  width: 100%;
}

.el-form-item {
  margin-bottom: 20px;
}

/* 表格样式优化 */
.table {
  width: 100%;
  overflow-x: auto;
}

.el-table {
  width: 100% !important;
  table-layout: auto;
}

.el-table .cell {
  word-break: break-word;
}

/* 确保表格容器最大化 */
.payment-config .box {
  width: 100%;
  max-width: none;
}

.payment-config .p16 {
  width: 100%;
}
</style>